import logitravelPanelErrorMobileStyles from "./styles/logitravel.js";
import partnershipsPanelErrorMobileStyles from "./styles/partnerships.js";
import smyPanelErrorMobileStyles from "./styles/smy.js";
import veciPanelErrorMobileStyles from "./styles/veci.js";
const panelErrorMobileThemes = {
    logitravel: logitravelPanelErrorMobileStyles,
    partnerships: partnershipsPanelErrorMobileStyles,
    smy: smyPanelErrorMobileStyles,
    veci: veciPanelErrorMobileStyles
};
export default panelErrorMobileThemes;

//# sourceMappingURL=index.js.map